import React from "react";
import { Building2, Loader2 } from "lucide-react";

interface Trade {
  id: string;
  name: string;
}

interface BusinessUnitMatcherProps {
  mappingId: string;
  businessUnitName: string;
  tradeId: string;
  trades: Trade[];
  onMappingChange: (
    mappingId: string,
    field: "businessUnitId" | "tradeId",
    value: string,
  ) => void;
  isSaving?: boolean;
}

const BusinessUnitMatcher: React.FC<BusinessUnitMatcherProps> = ({
  mappingId,
  businessUnitName,
  tradeId,
  trades,
  onMappingChange,
  isSaving = false,
}) => {
  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <Building2 className="h-5 w-5 text-gray-400 dark:text-slate-500 mr-3" />
          <div className="text-sm font-medium text-gray-900 dark:text-slate-100">
            {businessUnitName}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center gap-2">
          <select
            className="block w-full max-w-xs rounded-md border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-gray-900 dark:text-slate-100 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
            onChange={(e) =>
              onMappingChange(mappingId, "tradeId", e.target.value)
            }
            value={tradeId}
          >
            <option value="">Choose trade...</option>
            {trades.map((trade) => (
              <option key={trade.id} value={trade.id}>
                {trade.name}
              </option>
            ))}
          </select>
          {isSaving && (
            <Loader2 className="h-4 w-4 animate-spin text-green-600 dark:text-green-400" />
          )}
        </div>
      </td>
    </tr>
  );
};

export default BusinessUnitMatcher;
